import { CopilotGenericContent } from './copilotGeneric';

export enum CopilotDocumentIngestSourceType {
  Upload = 1,
  Library = 2,
}

export enum CopilotDocumentStorageSourceType {
  StorageAccount = 1,
  SharePoint = 2,
}

export enum CopilotDocumentIngestStatus {
  Ready = 1,
  UnsupportedFormat = 2,
  NotFound = 3,
  Expired = 4,
  Unauthorized = 5,
  Failed = 6,
}

export class CopilotDocumentCategorySuggestion {
  listId?: number;

  listName?: string;

  confidence?: number;

  rationale?: string;
}

export class CopilotDocumentIngest {
  sessionId?: number;

  contextKey?: string;

  sourceType: CopilotDocumentIngestSourceType;

  storageSourceType: CopilotDocumentStorageSourceType;

  uploadedBlobName?: string;

  libraryLinkId?: number;

  libraryListId?: number;

  title?: string;

  fileName?: string;

  mimeType?: string;

  markdown?: string;

  suggestedListId?: number;

  saveToLibraryListId?: number;

  categorySuggestion?: CopilotDocumentCategorySuggestion;

  constructor() {
    this.sourceType = CopilotDocumentIngestSourceType.Upload;
    this.storageSourceType = CopilotDocumentStorageSourceType.StorageAccount;
  }
}

export class CopilotDocumentIngestPayload {
  sourceType: CopilotDocumentIngestSourceType;

  storageSourceType: CopilotDocumentStorageSourceType;

  tempBlobName?: string;

  tempBlobExpires?: string;

  originalLibraryLinkId?: number;

  originalLibraryListId?: number;

  suggestedListId?: number;

  sourceTitle?: string;

  sourceFileName?: string;

  mimeType?: string;

  constructor() {
    this.sourceType = CopilotDocumentIngestSourceType.Upload;
    this.storageSourceType = CopilotDocumentStorageSourceType.StorageAccount;
  }
}

export class CopilotDocumentIngestResult {
  status: CopilotDocumentIngestStatus;

  message?: string;

  content?: CopilotGenericContent;

  payload?: CopilotDocumentIngestPayload;

  pendingIngest?: CopilotDocumentIngest;

  categorySuggestion?: CopilotDocumentCategorySuggestion;

  constructor() {
    this.status = CopilotDocumentIngestStatus.Failed;
  }
}
